import '../components/integer-input';
import '../components/numeric-dropdown-input';
import BaseProperties from "./base-properties";
import InputChangeEvent from "../components/input-change-event";
import IntegerInput from "../components/integer-input";
import NumericDropdownInput from "../components/numeric-dropdown-input";
import injectCSS from "../../../html/inject-css";
import logging from '../../../logging';
import { Cubby } from "../../../domain";

const log = logging('properties');

export default class CubbyProperties extends BaseProperties {

    declare model: Cubby;

    thickness: NumericDropdownInput;
    countY: IntegerInput;
    countX: IntegerInput;

    constructor(model: Cubby) {
        super(model);
    }

    connectedCallback() {
        log.debug("CubbyProperties.init()");

        this.innerHTML = HTML;
        injectCSS(STYLESHEET);

        // Cubby.thickness
        const thickness = this.thickness = this.querySelector("numeric-dropdown-input");
        thickness.value = this.model.thickness;

        thickness.addEventListener("change", (event) => {
            log.debug("CubbyProperties.thickness change", event, thickness.value);
            this.model.thickness = thickness.value as any;
            let name: string, description: string;
            if(event instanceof InputChangeEvent) {
                name = event.getChangeName();
                description = event.getChangeDescription();
            }
            else {
                const value = String(
                    thickness.value && typeof thickness.value == 'number'
                        ? (thickness.value as number).toFixed(3)
                        : thickness.value);
                name = "CubbyProperties/thickness";
                description = 'set Stock Size to ' + value
            }
            //this.app.commit(name, description);
        });

        this.model.on('thickness', () => {
            thickness.value = this.model.thickness;
        });

        // Cubby.countY
        const countY = this.countY =
            this.querySelector(".countY") as IntegerInput;
        //countY.parent = this;
        countY.value = this.model.countY;

        countY.addEventListener("change", (event) => {
            log.debug("CubbyProperties.countY change", event, countY.value);
            this.model.countY = countY.value as any;
            let name: string, description: string;
            if(event instanceof InputChangeEvent) {
                name = event.getChangeName();
                description = event.getChangeDescription();
            }
            else {
                const value = String(
                    countY.value && typeof countY.value == 'number'
                        ? (countY.value as number).toFixed(3)
                        : countY.value);
                name = "CubbyProperties/countY";
                description = 'set Rows to ' + value
            }
            //this.app.commit(name, description);
        });

        this.model.on('countY', () => {
            countY.value = this.model.countY;
        });

        // Cubby.countX
        const countX = this.countX = this.querySelector(".countX") as IntegerInput;
        //countX.parent = this;
        countX.value = this.model.countX;

        countX.addEventListener("change", (event) => {
            log.debug("CubbyProperties.countX change", event, countX.value);
            this.model.countX = countX.value as any;
            let name: string, description: string;
            if(event instanceof InputChangeEvent) {
                name = event.getChangeName();
                description = event.getChangeDescription();
            }
            else {
                const value = String(
                    countX.value && typeof countX.value == 'number'
                        ? (countX.value as number).toFixed(3)
                        : countX.value);
                name = "CubbyProperties/countX";
                description = 'set Columns to ' + value
            }
            //this.app.commit(name, description);
        });

        this.model.on('countX', () => {
            countX.value = this.model.countX;
        });
    }

}
window.customElements.define('cubby-properties', CubbyProperties); 
log.debug('Defined custom element <cubby-properties>');

const HTML = `
<h1>Cubby Properties</h1>
<div class="grid">
    <label>Rows</label>
    <integer-input min="1" max="9" class="countY"></integer-input>
    <label>Columns</label>
    <integer-input min="1" max="9" class="countX"></integer-input>
    <label>Stock Size</label>
    <numeric-dropdown-input>
        <option value="1">1 in</option>
        <option value="0.75">¾ in</option>
        <option value="0.5">½ in</option>
    </numeric-dropdown-input>
</div>
`;

const STYLESHEET = `
cubby-properties {
    & .grid {
        display: grid;
        grid-template-columns: auto 1fr auto 1fr;
        grid-column-gap: 12px;
        grid-row-gap: 12px;
        margin: 24px;
        align-items: center;
    }

    & h1 {
        text-transform: capitalize;
        font-size: 18px;
        margin-left: 24px;
    }

    & label {
        text-transform: capitalize;
    }
}
`;
